import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Tables, { ITablesProps } from '../Tables';
import Icon from 'tbk-components/src/components/Icon';

export interface IAntennaSelectionTable {
	/**
	 * Table Title
	 */
	title?: string;
	/**
	 * Table Description
	 */
	description?: string;
	/**
	 * Table Data
	 */
	tableData?: ITablesProps;
}

export interface IAntennaSelectionTablesProps extends IBaseElementProps {
	accordionName?: string;
	tables?: IAntennaSelectionTable[];
}

const AntennaSelectionTables: React.FC<IAntennaSelectionTablesProps> = ({
	accordionName,
	tables = [],
	className,
	classNames = [],
}) => {
	const [open, setOpen] = React.useState(false);

	return (
		<div
			className={
				className || cn('antenna-selection-tables', ...classNames)
			}
		>
			<div className="antenna-selection-tables__container">
				<div
					className={cn(
						'antenna-selection-tables__accordion',
						open ? 'open' : '',
					)}
				>
					<button
						className="antenna-selection-tables__accordion-button"
						onClick={() => setOpen(!open)}
					>
						<h5 className="antenna-selection-tables__accordion-title">
							<span>
								<Icon name={'border-all'} /> {accordionName}
							</span>
							<Icon name={'caret-down'} />
						</h5>
					</button>
					<div className="antenna-selection-tables__accordion-content">
						{tables.map((table, index) => (
							<div
								key={index}
								className="antenna-selection-tables__accordion-content__table"
							>
								<h4 className="antenna-selection-tables__accordion-content__table-title">
									{table?.title}
								</h4>
								<div className="antenna-selection-tables__accordion-content__table-description">
									{table?.description}
								</div>

								{table?.tableData && (
									<Tables {...table?.tableData} />
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AntennaSelectionTables;
